import React, { memo, useEffect, useState } from "react";
export var Step = memo(function (_a) {
    var label = _a.label, active = _a.active, isFirst = _a.isFirst, isLast = _a.isLast, labelColor = _a.labelColor, circleColor = _a.circleColor, Icon = _a.Icon;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(""), tColor = _c[0], setTcolor = _c[1];
    var _d = useState(""), crColor = _d[0], setCrColor = _d[1];
    var _e = useState("stepper-step"), classNames = _e[0], setClassNames = _e[1];
    useEffect(function () {
        if (active) {
            setClassNames(function (prev) { return prev + "  active-step"; });
        }
        else {
            setClassNames("stepper-step");
        }
    }, [active]);
    //// SET COLORS WHICH USER NEEDES
    useEffect(function () {
        if (!crColor && circleColor) {
            if (circleColor.startsWith("#")) {
                setCrColor("".concat(circleColor));
            }
            else {
                setCrColor(getComputedStyle(document.documentElement).getPropertyValue("--".concat(circleColor)));
            }
        }
        if (!tColor && labelColor) {
            if (labelColor.startsWith("#")) {
                setTcolor("".concat(labelColor));
            }
            else {
                setTcolor(getComputedStyle(document.documentElement).getPropertyValue("--".concat(labelColor)));
            }
        }
        if (crColor || tColor || !loading) {
            setLoading(true);
        }
    }, [circleColor, crColor, loading, tColor, labelColor]);
    return loading ? (React.createElement("div", { className: classNames },
        React.createElement("div", { className: "stepper-circle", style: {
                background: circleColor ? "".concat(crColor) : "",
                filter: !active ? "opacity(0.43)" : "none",
            } },
            React.createElement("span", null, typeof Icon === "function" ? Icon() : null)),
        React.createElement("div", { className: "stepper-title", style: {
                color: "".concat(tColor),
                filter: !active ? "opacity(0.43)" : "none",
            } }, label),
        !isFirst ? React.createElement("div", { className: "stepper-bar-left" }) : null,
        !isLast ? React.createElement("div", { className: "stepper-bar-right" }) : null)) : null;
}, function (prevProps, nextProps) {
    return prevProps.active === nextProps.active;
});
